import React, { useCallback, useContext, useEffect, useState } from "react";
import { Form, Row, Col, Input, Select, Divider, Radio, Upload, Button, Switch, Typography, Spin, Card, Checkbox, Segmented } from "antd";
import { UploadOutlined, DownloadOutlined, PlusOutlined, DeleteOutlined, LoadingOutlined } from '@ant-design/icons';
import AddPhysicianModalWrapper from "../../../modal/AddPhysicianModalWrapper";
import { CustomButton, CustomSecondaryButton } from "../styled";
import { physicianService } from "../../../../services/user";
import { debounce, notify } from "../../../../utils/helper";
import styled from "styled-components";
import { extractToken } from "../../../../utils/localStorage";
import { globalRoles } from "../../../../utils/roles";
import { decyprtData } from "../../../../utils/axios";
import { SpecilityContext } from "../../../../context/SpecilityContext";
import { limitedcountry } from "../../../../utils/utils";
import { validateZipCode } from "../../../../utils/utils";

const { Option } = Select;

export const groupOptions = [
  { value: "681c5ce641fd75245cde5ee6", label: "Cardiology Group" },
  { value: "681c5ce641fd75245cde5ee7", label: "Primary Care Associates" },
  { value: "681c5ce641fd75245cde5ee5", label: "Surgical Specialists" },
  { value: "681c5ce641fd75245cde5ee4", label: "Pediatric Team" },
  { value: "681c5ce641fd75245cde5ee3", label: "Emergency Medicine Group" },
];

export const statusOptions = [
  { value: true, label: "Active" },
  { value: false, label: "Inactive" },
];

const FormContainer = styled.div`
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;
  width: 100%;

  /* Scrollbar styling */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

const SectionContainer = styled.div`
  opacity: ${props => props.show ? 1 : 0};
  transform: translateY(${props => props.show ? '0' : '10px'});
  transition: all 0.3s ease-in-out;
  pointer-events: ${props => props.show ? 'auto' : 'none'};
  position: ${props => props.show ? 'relative' : 'absolute'};
  width: 100%;
  
  ${props => !props.show && `
    height: 0;
    overflow: hidden;
  `}
`;

const IndividualSection = styled.div`
  padding: 24px;
  background: var(--primary-bg);
  border-radius: 8px;
  border: 1px solid var(--border-color);
  
  .section-title {
    font-size: 16px;
    font-weight: 500;
    color: var(--primary-text-color);
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid var(--border-color);
  }
  
  // .ant-form-item-label > label {
  //   font-weight: 500;
  //   color: var(--primary-text-color);
  // }
  
  .ant-input, .ant-select-selector {
    border-radius: 6px;
    transition: all 0.3s;
    
    &:hover {
      border-color: rgba(138, 62, 244, 0.5);
    }
    
    &:focus, &.ant-select-focused .ant-select-selector {
      border-color: rgba(138, 62, 244, 0.7);
      box-shadow: 0 0 0 2px rgba(138, 62, 244, 0.1);
    }
  }
  .customZipSpin {
    position: absolute;
    z-index: 1;
    top: 10px;
    right: 10px
  }
`;

const SectionTitle = styled.h4`
  font-size: 16px;
  font-weight: 600;
  color: var(--primary-text-color);
  margin-bottom: 5px;
`;

const CustomPassword = styled.div`
  .ant-input-affix-wrapper {
    position: relative;
    display: inline-block;
    width: 100%;
    min-width: 0;
    padding: 1.5px 11px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    line-height: 1.5715;
    background-color: transparent !important;
    background-image: none;
    border: 1px solid var(--border-color) !important;
    border-radius: 6px;
    transition: all 0.3s;
    display: inline-flex;
  }
`;

const ToggleContainer = styled.div`
  margin-bottom: 24px;
  padding: 16px;
  background: var(--primary-bg);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border-color);

  .ant-switch-inner {
    display: block;
    margin: 0px 28px 0px 25px;
    color: var(--primary-text-color);
    font-size: 12px;
    transition: margin .2s; 
    font-weight: 700;
    font-family: "Inter", sans-serif;
  }

  .toggle-label {
    display: flex;
    align-items: center;
    gap: 8px;
    
    .ant-typography {
      margin: 0;
      font-weight: 500;
      color: var(--primary-text-color);
    }
  }
  .ant-switch-checked {
    background-color: rgba(138, 62, 244, 0.7) !important;
  }
  .ant-switch:focus{
    box-shadow: none;
  }
`;

const GroupSection = styled.div`
  margin-top: 16px;
  padding: 20px;
  background: var(--primary-bg);
  border-radius: 8px;
  border: 1px solid var(--border-color);

  .ant-form-item-extra{
    color: var(--secondary-text-color);
  }
`;

const PhysicianFormCard = styled(Card)`
  margin-bottom: 16px;
  
  .ant-card-head-wrapper {
  min-height: 40px !important;
    height: 40px;
}

  .ant-card-head {
    background: var(--secondary-bg);
    border-bottom: 1px solid var(--border-color);
    height: 40px;
    
    .ant-card-head-title {
      font-size: 14px;
      font-weight: 500;
      color: var(--primary-text-color);
    }
  }

  .ant-card-body {
    padding: 16px;
    border: 1px solid var(--border-color);
  }

  .ant-card-extra {
    .ant-btn {
      border: none;
      box-shadow: none;
      color: #ff4d4f;
      
      &:hover {
        background: #fff2f0;
        color: #ff4d4f;
      }
    }
  }
`;

const AddPhysicianButton = styled(Button)`
  width: 100%;
  height: 48px;
  border: 2px dashed var(--border-color);
  background: transparent;
  color: var(--primary-text-color);
  
  &:hover {
    border-color: rgba(138, 62, 244, 0.7);
    color: rgba(138, 62, 244, 0.7);
    background: rgba(138, 62, 244, 0.05);
  }
`;

const SampleFileContainer = styled.div`
  background: var(--border-color);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .sample-text {
    color: var(--primary-text-color);
    font-size: 13px;
    margin: 0;
  }

  .download-link {
    color: #1890ff;
    font-size: 13px;
    cursor: pointer;
    text-decoration: underline;
    display: flex;
    align-items: center;
    gap: 4px;

    &:hover {
      color: #40a9ff;
    }
  }
`;

const GroupMethodSection = styled.div`
  margin-top: 20px;
  padding: 20px;
  background: var(--secondary-bg);
  border-radius: 8px;
  border: 1px solid var(--border-color);

  .method-title {
    font-size: 16px;
    font-weight: 500;
    color: var(--primary-text-color);
    margin-bottom: 16px;
  }
`;

const AddPhysicianFormModal = ({
  isOpen,
  setOpen,
  isEdit,
  setIsEdit,
  selectedPhysicianId,
  fetchPhysician,
  isGroup,
}) => {
  const [physicianData, setPhysicianData] = useState([]);
  const [physicianType, setPhysicianType] = useState(isGroup ? 'group' : 'individual');
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [groupPhysicians, setGroupPhysicians] = useState(
    Array.from({ length: 10 }, (_, i) => ({ id: i + 1 }))
  );
  const [previewData, setPreviewData] = useState([]);
  const [isPreviewMode, setIsPreviewMode] = useState(false);
  const [showUploadInGroup, setShowUploadInGroup] = useState(false);
  const [groupType, setGroupType] = useState("");
  const { specialtyOptions } = useContext(SpecilityContext);
  const [zip, setZip] = useState('');
  const [countryName, setCountryName] = useState('');
  const [message, setMessage] = useState('');
  const [zipLoading, setZipLoading] = useState(false);
  const [zipData, setZipData] = useState(null);
  const [groupZip, setGroupZip] = useState({});
  const [groupmessage, setGroupMessage] = useState({});
  const [groupZipLoading, setGroupZipLoading] = useState({});
  const [groupZipData, setGroupZipData] = useState({});
  const [zipValidationResults, setZipValidationResults] = useState({});

  const user = extractToken();

  // Function to download sample CSV file
  const downloadSampleFile = () => {
    const link = document.createElement('a');
    link.href = '/physician.xlsx';
    link.setAttribute('download', 'physician.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Add new physician form (not used anymore since we show 10 rows by default)
  const addPhysicianForm = () => {
    if (groupPhysicians.length < 10) {
      const newId = Math.max(...groupPhysicians.map(p => p.id)) + 1;
      setGroupPhysicians([...groupPhysicians, { id: newId }]);
    }
  };

  // Remove physician form
  const removePhysicianForm = (id) => {
    if (groupPhysicians.length > 1) {
      setGroupPhysicians(groupPhysicians.filter(p => p.id !== id));
      // Clear form fields for removed physician
      const fieldsToRemove = [`physician_${id}_name`, `physician_${id}_email`, `physician_${id}_specialty`, `physician_${id}_boardMember`];
      const currentValues = form.getFieldsValue();
      fieldsToRemove.forEach(field => {
        delete currentValues[field];
      });
      form.setFieldsValue(currentValues);
    }
  };

  const createPhysician = async (values) => {
    try {
      setLoading(true);
      
      if (physicianType === 'individual') {
        // For individual physicians, only send required fields
        let physicianData = {
          name: values.name,
          email: values.email,
          specialty: values.specialty,
          zip: String(zip),
          country: countryName,
          ...(zipData && {timeZone: zipData}),
        };

        // Only include boardMember if user is SUPERADMIN
        if (user?.role === globalRoles.SUPERADMIN) {
          physicianData.boardMember = values.boardMember === "true";
        }
        if (isEdit) {
          const response = await physicianService.update(selectedPhysicianId, physicianData);
          notify("success", "Physician Updated Successfully.");
        } else {
          const response = await physicianService.create(physicianData);
          notify("success", "Physician Created Successfully.");
        }
      } else {
        // Handle group creation
        if (values.physicianFile && !isPreviewMode) {
          
          // First step: Preview the file
          const formData = new FormData();
          formData.append('file', values.physicianFile.file);
          const response = await physicianService.previewImport(formData);
          const previewPhysicians = decyprtData(response?.data);
          // console.log("responseUploadfile:", previewPhysicians);
            
          // Set preview data and enter preview mode
          const previewUser = previewPhysicians?.users.map((physician, index) => ({
            ...physician,
            id: index + 1
          }));
          await validateUploadedZips(previewUser)
          setPreviewData(previewUser)
          setIsPreviewMode(true);
          setLoading(false);
          notify("info", "File preview loaded. Please review and fix any duplicates before uploading.");
          return; // Don't close modal, stay in preview mode
        } else if (isPreviewMode) {
          // Second step: Actual upload after review
          // Filter out any physicians that might have been removed or have invalid data
          const validPhysicians = previewData.filter(p => p.name && p.email && p.zip && p.country);
          //console.log("validPhysicians:", validPhysicians);
          
          if (validPhysicians.length === 0) {
            notify("error", "Please ensure at least one physician has valid data (name, email, and specialty).");
            setLoading(false);
            return;
          }

          const hasAlreadyRegistered = validPhysicians.some(p => p.alreadyRegistered === true);
          if (hasAlreadyRegistered) {
            notify("error", "Some emails are already registered. Please remove or update them before uploading.");
            setLoading(false);
            return;
          }

          const hasInvalidZip = validPhysicians.some((_, index) => zipValidationResults[index].status !== 'ZIP is valid');
          if (hasInvalidZip) {
            notify("error", "Some ZIP codes are invalid. Please check and correct them before uploading.");
            setLoading(false);
            return;
          }

          // Send the modified preview data in the same format as preview response
          const uploadPayload = {
            users: validPhysicians.map(({ id, ...physician }, index) => ({ 
              ...physician,
              specialty: values.specialties,
              timeZone: zipValidationResults[index]?.info
          })),
            company: values.groupName || "Default Group",
            specialties: [values.specialties],
            description: values.description,
          };

          // console.log("uploadPayload:", uploadPayload);

          const response = await physicianService.uploadFile(uploadPayload);
          // console.log("uploadResponse:", response);
          notify("success", `${validPhysicians.length} physicians uploaded successfully!`);
        } else {
          // Manual group creation
          const physiciansToCreate = groupPhysicians.map(physician => {
            const physicianData = {
              name: values[`physician_${physician.id}_name`],
              email: values[`physician_${physician.id}_email`],
              specialty: values.specialties,
              boardMember: user?.role === globalRoles.SUPERADMIN 
                ? (values[`physician_${physician.id}_boardMember`] === "true")
                : false,
              country: values[`physician_${physician.id}_country`],
              zip: groupZip[`physician_${physician.id}_zip`],
              timeZone: groupZipData[physician.id],
            };
            // console.log(`Physician ${physician.id} data:`, physicianData);
            return physicianData;
          }).filter(p => p.name && p.email && p.specialty && p.zip); // Only include physicians with required fields


          if (physiciansToCreate.length === 0) {
            notify("error", "Please fill in all required fields for at least one physician.");
            setLoading(false);
            return;
          }

          // Prepare group payload
          const groupPayload = {
            company: values.groupName,
            specialties: [values.specialties],
            description: values.description,
            type: values.type,
            users: physiciansToCreate
          };


          // Create group of physicians
          const response = await physicianService.uploadFile(groupPayload);
          notify("success", `Group "${values.groupName}" with ${physiciansToCreate.length} physicians created successfully.`);
        }
      }
      
      setOpen(false);
      setIsEdit(false);
      setLoading(false);
      fetchPhysician();
    } catch (error) {
      console.error("Error creating physician(s):", error);
      notify("error", error?.data?.message || "Error creating physician(s).");
      setLoading(false);
    }
  };

  const getPhysicianById = async () => {
    try {
      const res = await physicianService.getById(selectedPhysicianId);
      setPhysicianData(res?.data);
    } catch (err) {}
  };

  useEffect(() => {
    if (isEdit) {
      getPhysicianById();
    }
  }, [selectedPhysicianId]);

  const [form] = Form.useForm();
  useEffect(() => {
    if (isEdit) {
      form.setFieldsValue({
        name: physicianData?.name || "",
        email: physicianData?.email || "",
        specialty: physicianData?.specialty || "N/A" || "",
        boardMember: physicianData?.boardMember ? "true" : "false",
        status: physicianData?.status || "",
        zip: physicianData?.zip || "",
        country: physicianData?.country || ""
      });
    } else {
      form.setFieldsValue({
        name: "",
        email: "",
        specialty: undefined,
        boardMember: "false",
        groupName: "",
        zip: "",
        country: undefined,
      });
    }
  }, [physicianData, form, isEdit]);

  const onClose = () => {
    setIsEdit(false);
    setOpen(false);
    setGroupPhysicians(Array.from({ length: 10 }, (_, i) => ({ id: i + 1 })));
    setPreviewData([]);
    setIsPreviewMode(false);
    setShowUploadInGroup(false);
    setFileList([]);
    form.resetFields();
  };

  const handleFileChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  const uploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([...fileList, file]);
      return false;
    },
    fileList,
  };

  const validateDebounced = useCallback(
    debounce(async (zipVal, countryCodeVal) => {
      setZipLoading(true);
      try {
        const msg = await validateZipCode(zipVal, countryCodeVal);
        setMessage(msg.message);
        setZipData(msg.data);
      } catch (err) {
        setMessage('Error validating ZIP');
        setZipLoading(false)
      } finally {
        setZipLoading(false)
      }
    }, 600),
    []
  );

  const validateGroupDebounced = useCallback(
    debounce(async (zipVal, countryCodeVal, physicianId) => {
      setGroupZipLoading(prev => ({ ...prev, [physicianId]: true }));
      try {
        const msg = await validateZipCode(zipVal, countryCodeVal);
        setGroupMessage(prev => ({ ...prev, [physicianId]: msg.message }));
        setGroupZipData(prev => ({ ...prev, [physicianId]: msg.data }));
      } catch (err) {
        setGroupMessage(prev => ({ ...prev, [physicianId]: 'Error validating ZIP' }));
      } finally {
        setGroupZipLoading(prev => ({ ...prev, [physicianId]: false }))
      }
    }, 600),
    []
  );

  const handleZipChange = (e) => {
    const value = e.target.value;
    setZip(value);
    if (value.length >= 3) {
      validateDebounced(value, countryName);
    } else {
      setMessage('');
      setZipData(null);
    }
  };

  const handleGroupZipChange = (e, physicianId) => {
    const value = e.target.value;
    setGroupZip(prev => ({
      ...prev,
      [`physician_${physicianId}_zip`]: value
    }));
    if(value.length >= 3){
      validateGroupDebounced(value, countryName, physicianId);
    } else {
      setGroupMessage(prev => ({ ...prev, [physicianId]: '' }));
      setGroupZipData(prev => ({ ...prev, [physicianId]: null }));
    }
  }

  const validateUploadedZips = async (uploadedData) => {
    const results = {};
  
    for (let i = 0; i < uploadedData.length; i++) {
      const item = uploadedData[i];
      const result = await validateZipCode(item.zip, item.country);
      results[i] = {
        status: result.data ? 'ZIP is valid' : 'Invalid ZIP for selected country',
        info: result.data,
      }
    }
    setZipValidationResults(results);
  };

  useEffect(() => {
    if(physicianData){
    setCountryName(physicianData?.country)
    setZip(physicianData?.zip)
    }
  }, [physicianData])
  

  return (
    <AddPhysicianModalWrapper
      show={isOpen}
      setShow={onClose}
      title={
        isEdit ? (
          <div className="row-flex flex-column">
            <h3 className="font-18 font-semibold text-primary mb-5">
              Update Physician
            </h3>
            <span className="font-15 text-secondry">
              Edit the physician's information below.
            </span>
          </div>
        ) : (
          <div className="row-flex flex-column">
            <h3 className="font-18 font-semibold text-primary mb-5">
              {isGroup ? "Add New Group" : "Add New Physician"}
            </h3>
            <span className="font-15 text-secondry">
              Enter the details to add {isGroup?"a new group":"physician(s)"} to the platform.
            </span>
          </div>
        )
      }
      footer={null}
      width={880}
      keyClose={false}
      className="custom-detail-modal"
    >
    <Spin spinning={loading}>
      <Form
        form={form}
        layout="vertical"
        onFinish={createPhysician}
        loading={loading}
        onValuesChange={(changed) => { if (changed.type !== undefined) setGroupType(changed.type); }}
      >
        <FormContainer>
          {(!isEdit && !isGroup) && (
            <ToggleContainer>
              <div className="toggle-label">
                <Typography.Text>Individual</Typography.Text>
                <Switch
                  checked={physicianType === 'group'}
                  onChange={(checked) => setPhysicianType(checked ? 'group' : 'individual')}
                  checkedChildren="Group"
                  unCheckedChildren="Individual"
                />
                <Typography.Text>Group</Typography.Text>
              </div>
            </ToggleContainer>
          )}

          <SectionContainer show={physicianType === 'individual'}>
            <IndividualSection>
              <div className="section-title font-16 text-primary" style={{fontWeight: 600}}>Physician Information</div>
              <Row gutter={[24, 16]}>
                <Col span={12}>
                  <Form.Item
                    name="name"
                    label="Full Name"
                    rules={[
                      () => ({
                        validator(_, value) {
                          // Only require name when in individual mode
                          if (physicianType === 'individual' && !value) {
                            return Promise.reject(new Error('Please input the full name!'));
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                  >
                    <Input placeholder="Enter Full Name" size="large" />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    name="specialty"
                    label="Medical Specialty"
                    rules={[
                      () => ({
                        validator(_, value) {
                          // Only require specialty when in individual mode
                          if (physicianType === 'individual' && !value) {
                            return Promise.reject(new Error('Please select a specialty!'));
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                  >
                    <Select
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      placeholder="Select Medical Specialty"
                      showSearch
                      style={{ width: '100%' }}
                      dropdownStyle={{ maxHeight: 200, overflowY: 'auto', overflowX: 'hidden' }}
                      listHeight={160}
                      options={specialtyOptions}
                      size="large"
                      loading={loading}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    name="country"
                    label="Country"
                    rules={[
                      () => ({
                        validator(_, value) {
                          if (physicianType === 'individual' && !countryName) {
                            return Promise.reject(new Error('Please select country!'));
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                  >
                    <Select
                      style={{ width: '100%' }}
                      showSearch
                      placeholder="Select Country"
                      dropdownStyle={{ maxHeight: 200, overflowY: 'auto', overflowX: 'hidden' }}
                      listHeight={160}
                      value={countryName}
                      onChange={(value)=> setCountryName(value)}
                      optionLabelProp="label"
                      filterOption={(input, option) =>
                        option?.label.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {limitedcountry.map((country) => (
                        <Option
                          value={country.code}
                          label={country.name}
                        >
                          <span>{country.name}</span>
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={9}>
                  <Form.Item
                    name="zip"
                    label="Zip Code"
                    rules={[
                      () => ({
                        validator(_, value) {
                          // Only require zip code when in individual mode
                          if (physicianType === 'individual' && !zip) {
                            return Promise.reject(new Error('Please input the zip code!'));
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                  >
                    <Input 
                      type="text"
                      placeholder="e.g., 560034"
                      value={zip}
                      onChange={handleZipChange}
                      loading={zipLoading}
                    />
                    {zipLoading ? (
                    <Spin indicator={<LoadingOutlined spin />} className="customZipSpin"/>
                    ):(<span className="customZipSpin font-12 text-primary">{zipData && zipData}</span>)}
                  {message && (
                    <p className="m-0" style={{color: zipData?"green":"red", fontSize: "13px" }}>{message}</p>
                  )}
                  </Form.Item>
                </Col>

                {user?.role === globalRoles.SUPERADMIN && (
                  <Col span={9}>
                    <Form.Item
                      name="boardMember"
                      label="Board Member Status"
                      rules={[
                        () => ({
                          validator(_, value) {
                            // Only require board member selection when in individual mode
                            if (physicianType === 'individual' && !value) {
                              return Promise.reject(new Error('Please select an option!'));
                            }
                            return Promise.resolve();
                          },
                        }),
                      ]}
                      initialValue={"false"}
                    >
                      <Radio.Group size="large">
                        <Radio value="true">Yes</Radio>
                        <Radio value="false">No</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                )}

                <Col span={24}>
                  <Form.Item
                    name="email"
                    label="Email Address"
                    rules={[
                      { type: "email", message: "Please enter a valid email address!" },
                      () => ({
                        validator(_, value) {
                          // Only require email when in individual mode
                          if (physicianType === 'individual' && !value) {
                            return Promise.reject(new Error('Please input your email!'));
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                  >
                    <Input placeholder="Enter Email Address" size="large" />
                  </Form.Item>
                </Col>
              </Row>
            </IndividualSection>
          </SectionContainer>

          <SectionContainer show={physicianType === 'group'}>
            <GroupSection>
              
              {/* Group Name Input */}
              <Row gutter={[24, 16]}>
                <Col span={12}>
                  <Form.Item
                    name="groupName"
                    label="Group Name"
                    rules={[
                      () => ({
                        validator(_, value) {
                          // Only require group name when in group mode
                          if (physicianType === 'group' && !value) {
                            return Promise.reject(new Error('Please enter the group name!'));
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                  >
                    <Input
                      placeholder="Enter Group Name (e.g., Cardiology Team, Surgery Department)"
                      size="large"
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="specialties"
                    label="Specialty"
                    rules={[
                      () => ({
                        validator(_, value) {
                          // Only require group name when in group mode
                          if (physicianType === 'group' && !value) {
                            return Promise.reject(new Error('Please enter the group name!'));
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                  >
                    <Select
                      getPopupContainer={(triggerNode) =>
                        triggerNode.parentNode
                      }
                      placeholder="Select Specialty"
                      showSearch
                      style={{ width: "100%" }}
                      dropdownStyle={{
                        maxHeight: 200,
                        overflowY: "auto",
                        overflowX: "hidden",
                      }}
                      listHeight={160}
                      options={specialtyOptions}
                      size="large"
                      loading={loading}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                                  <Form.Item
                                    name="type"
                                    label="Group Type"
                                    rules={[
                                      () => ({
                                        validator(_, value) {
                                          // Only require group type when in group mode
                                          if (physicianType === 'group' && !value) {
                                            return Promise.reject(new Error('Please select group type!'));
                                          }
                                          return Promise.resolve();
                                        },
                                      }),
                                    ]}
                                  >
                                    <Select
                                      getPopupContainer={(triggerNode) =>
                                        triggerNode.parentNode
                                      }
                                      placeholder="Select Type"
                                      showSearch
                                      style={{ width: "100%" }}
                                      dropdownStyle={{
                                        maxHeight: 200,
                                        overflowY: "auto",
                                        overflowX: "hidden",
                                      }}
                                      listHeight={160}
                                      // options={specialtyOptions}
                                      size="large"
                                      loading={loading}
                                      filterOption={(input, option) =>
                                        (option?.label ?? "")
                                          .toLowerCase()
                                          .includes(input.toLowerCase())
                                      }
                                    >
                                      <Select.Option value="clinical" style={{ color: '#000' }}>Clinical</Select.Option>
                                      <Select.Option value="ccm" style={{ color: '#000' }}>CCM</Select.Option>
                                    </Select>
                                  </Form.Item>
                                </Col>
                <Col span={24}>
                  <Form.Item
                    name="description"
                    label="Description"
                    rules={[
                      () => ({
                        validator(_, value) {
                          // Only require group name when in group mode
                          if (physicianType === 'group' && !value) {
                            return Promise.reject(new Error('Please enter the group name!'));
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                  >
                    <Input.TextArea
                      placeholder="Enter Description"
                      rows={4}
                      size="large"
                    />
                  </Form.Item>
                </Col>
              </Row>

              {/* Individual Physician Forms */}
              <div style={{ marginBottom: '20px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                  <div>
                    <Typography.Text strong style={{ color: 'var(--primary-text-color)', marginBottom: '8px', display: 'block' }}>
                      {showUploadInGroup ? (groupType === 'ccm' ? 'Upload Coordinator File' : 'Upload Physician File') : groupType === 'ccm' ? 'Add Coordinator (Up to 10 Coordinator)' : 'Add Physicians (Up to 10 Physicians)'}
                    </Typography.Text>
                    <Typography.Text style={{ color: 'var(--secondary-text-color)', marginBottom: '16px', display: 'block', fontSize: '13px' }}>
                      {showUploadInGroup 
                        ? (isPreviewMode 
                            ? 'Review the data below. Users with red background are already registered - please update their email or remove them.'
                            : 'Upload a CSV or Excel file containing physician details for bulk creation.'
                          )
                        : groupType === 'ccm'
                          ? 'Fill at least one complete coordinator. If you start filling a row, all fields in that row become required.'
                          : 'Fill at least one complete physician. If you start filling a row, all fields in that row become required.'
                      }
                    </Typography.Text>
                  </div>
                  <Button 
                    type={showUploadInGroup ? "default" : "primary"}
                    size="small"
                    icon={<UploadOutlined />}
                    onClick={() => setShowUploadInGroup(!showUploadInGroup)}
                    style={{ 
                      marginTop: '2px',
                      fontWeight: '500',
                      color: "var(--primary-text-color)"
                    }}
                  >
                    {showUploadInGroup ? 'Manual Entry' : 'Upload File'}
                  </Button>
                </div>
                
                {!showUploadInGroup ? (
                  <>
                    {/* Sticky Header */}
                    <div style={{ 
                      position: 'sticky', 
                      top: '0', 
                      zIndex: 10, 
                      background: 'var(--secondary-bg)', 
                      border: '1px solid var(--border-color)', 
                      borderRadius: '4px 4px 0 0',
                      padding: '8px',
                      marginBottom: '0'
                    }}>
                      <Row gutter={[8, 0]} align="middle" className="w-100">
                        <Col span={1}>
                          <div style={{ 
                            fontSize: '13px', 
                            fontWeight: '600', 
                            color: 'var(--primary-text-color)', 
                            textAlign: 'center'
                          }}>
                            #
                          </div>
                        </Col>
                        <Col span={6}>
                          <div style={{ 
                            fontSize: '13px', 
                            fontWeight: '600', 
                            color: 'var(--primary-text-color)'
                          }}>
                            Full Name
                          </div>
                        </Col>
                        <Col span={6}>
                          <div style={{ 
                            fontSize: '13px', 
                            fontWeight: '600', 
                            color: 'var(--primary-text-color)'
                          }}>
                            Email
                          </div>
                        </Col>
                        {/* <Col span={5}>
                          <div style={{ 
                            fontSize: '13px', 
                            fontWeight: '600', 
                            color: 'var(--primary-text-color)'
                          }}>
                            Specialty
                          </div>
                        </Col> */}
                        <Col span={5}>
                          <div style={{ 
                            fontSize: '13px', 
                            fontWeight: '600', 
                            color: 'var(--primary-text-color)'
                          }}>
                            Country
                          </div>
                        </Col>
                        <Col span={6}>
                          <div style={{ 
                            fontSize: '13px', 
                            fontWeight: '600', 
                            color: 'var(--primary-text-color)'
                          }}>
                            Zip Code
                          </div>
                        </Col>
                      </Row>
                    </div>

                    {/* Scrollable Rows */}
                    <div style={{ 
                      maxHeight: '300px', 
                      overflowY: 'auto',
                      border: '1px solid var(--border-color)',
                      borderTop: 'none',
                      borderRadius: '0 0 4px 4px'
                    }}>
                      {groupPhysicians.map((physician, index) => (
                        <div key={physician.id} style={{ 
                          padding: '8px', 
                          borderBottom: index < groupPhysicians.length - 1 ? '1px solid var(--border-color)' : 'none',
                          background: 'var(--primary-bg)',
                          '&:hover': { background: 'var(--secondary-bg)' }
                        }}>
                          <Row gutter={[8, 0]} align="middle">
                            <Col span={1}>
                              <div style={{ 
                                fontSize: '13px', 
                                fontWeight: '500', 
                                color: 'var(--secondary-text-color)', 
                                textAlign: 'center'
                              }}>
                                {index + 1}
                              </div>
                            </Col>
                            
                            <Col span={6}>
                              <Form.Item
                                name={`physician_${physician.id}_name`}
                                rules={[
                                  ({ getFieldValue }) => ({
                                    validator(_, value) {
                                      // Skip validation if not in group mode or showing upload
                                      if (physicianType !== 'group' || showUploadInGroup) {
                                        return Promise.resolve();
                                      }
                                      
                                      const email = getFieldValue(`physician_${physician.id}_email`);
                                      // const specialty = getFieldValue(`physician_${physician.id}_specialty`);
                                      
                                      // If any field is filled, all fields are required for this physician
                                      if (email) {
                                        if (!value) {
                                          return Promise.reject(new Error('Name is required when email or specialty is provided!'));
                                        }
                                      }
                                      
                                      // If this is the first physician and no other physicians are filled, require at least this one
                                      if (physician.id === 1) {
                                        const allValues = form.getFieldsValue();
                                        const hasAnyOtherPhysician = groupPhysicians.slice(1).some(p => 
                                          allValues[`physician_${p.id}_name`] || 
                                          allValues[`physician_${p.id}_email`] 
                                          // allValues[`physician_${p.id}_specialty`]
                                        );
                                        
                                        if (!hasAnyOtherPhysician && !value && !email) {
                                          return Promise.reject(new Error('At least one physician is required!'));
                                        }
                                      }
                                      
                                      return Promise.resolve();
                                    },
                                  }),
                                ]}
                                style={{ marginBottom: '0' }}
                              >
                                <Input placeholder="Enter Full Name" size="small" />
                              </Form.Item>
                            </Col>
                            
                            <Col span={6}>
                              <Form.Item
                                name={`physician_${physician.id}_email`}
                                rules={[
                                  { type: "email", message: "Please enter a valid email!" },
                                  ({ getFieldValue }) => ({
                                    validator(_, value) {
                                      // Skip validation if not in group mode or showing upload
                                      if (physicianType !== 'group' || showUploadInGroup) {
                                        return Promise.resolve();
                                      }
                                      
                                      const name = getFieldValue(`physician_${physician.id}_name`);
                                      // const specialty = getFieldValue(`physician_${physician.id}_specialty`);
                                      
                                      // If any field is filled, all fields are required for this physician
                                      if (name) {
                                        if (!value) {
                                          return Promise.reject(new Error('Email is required when name is provided!'));
                                        }
                                      }
                                      
                                      return Promise.resolve();
                                    },
                                  }),
                                ]}
                                style={{ marginBottom: '0' }}
                              >
                                <Input placeholder="Email address" size="small" />
                              </Form.Item>
                            </Col>
                            
                            {/* <Col span={5}>
                              <Form.Item
                                name={`physician_${physician.id}_specialty`}
                                rules={[
                                  ({ getFieldValue }) => ({
                                    validator(_, value) {
                                      // Skip validation if not in group mode or showing upload
                                      if (physicianType !== 'group' || showUploadInGroup) {
                                        return Promise.resolve();
                                      }
                                      
                                      const name = getFieldValue(`physician_${physician.id}_name`);
                                      const email = getFieldValue(`physician_${physician.id}_email`);
                                      
                                      // If any field is filled, all fields are required for this physician
                                      if (name || email) {
                                        if (!value) {
                                          return Promise.reject(new Error('Specialty is required when name or email is provided!'));
                                        }
                                      }
                                      
                                      return Promise.resolve();
                                    },
                                  }),
                                ]}
                                style={{ marginBottom: '0' }}
                              >
                                <Select
                                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                  placeholder="Select Specialty"
                                  showSearch
                                  size="small"
                                  style={{ width: '100%' }}
                                  dropdownStyle={{ maxHeight: 200, overflowY: 'auto', overflowX: 'hidden' }}
                                  listHeight={160}
                                  options={specialtyOptions}
                                  loading={loading}
                                  filterOption={(input, option) =>
                                    (option?.label ?? "")
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                />
                              </Form.Item>
                            </Col> */}

                            <Col span={5}>
                              <Form.Item
                                name={`physician_${physician.id}_country`}
                                rules={[
                                  ({ getFieldValue }) => ({
                                    validator(_, value) {
                                      // Skip validation if not in group mode or showing upload
                                      if (physicianType !== 'group' || showUploadInGroup) {
                                        return Promise.resolve();
                                      }
                                      
                                      const name = getFieldValue(`physician_${physician.id}_name`);
                                      const email = getFieldValue(`physician_${physician.id}_email`);
                                      // const zip = getFieldValue(`physician_${physician.id}_zip`);
                                      
                                      // If any field is filled, all fields are required for this physician
                                      if (name || email) {
                                        if (!countryName) {
                                          return Promise.reject(new Error('Country is required when name or email is provided!'));
                                        }
                                      }
                                      
                                      return Promise.resolve();
                                    },
                                  }),
                                ]}
                                style={{ marginBottom: '0' }}
                              >
                                <Select
                                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                  placeholder="Select Country"
                                  showSearch
                                  size="small"
                                  style={{ width: '100%' }}
                                  dropdownStyle={{ maxHeight: 200, overflowY: 'auto', overflowX: 'hidden' }}
                                  listHeight={120}
                                  value={countryName}
                                  onChange={(value)=> setCountryName(value)}
                                  optionLabelProp="label"
                                  filterOption={(input, option) =>
                                    (option?.label ?? "")
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                >
                                  {limitedcountry.map((country)=> (
                                    <Option
                                      value={country.code}
                                      label={country.name}
                                    >
                                      <span>{country.name}</span>
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </Col>

                            <Col span={6}>
                              <Form.Item
                                name={`physician_${physician.id}_zip`}
                                rules={[
                                  ({ getFieldValue }) => ({
                                    validator(_, value) {
                                      // Skip validation if not in group mode or showing upload
                                      if (physicianType !== 'group' || showUploadInGroup) {
                                        return Promise.resolve();
                                      }
                                      
                                      const name = getFieldValue(`physician_${physician.id}_name`);
                                      const email = getFieldValue(`physician_${physician.id}_email`);
                                      // const zip = getFieldValue(`physician_${physician.id}_zip`);
                                      // const specialty = getFieldValue(`physician_${physician.id}_specialty`)
                                      
                                      // If any field is filled, all fields are required for this physician
                                      if (name || email) {
                                        if (!groupZip) {
                                          return Promise.reject(new Error('Zip is required when name or email is provided!'));
                                        }
                                      }
                                      
                                      return Promise.resolve();
                                    },
                                  }),
                                ]}
                                style={{ marginBottom: '0' }}
                              >
                                <Input 
                                  type="text"
                                  placeholder="Enter Zip Code" 
                                  size="small" 
                                  // value={zip}
                                  onChange={(e)=>handleGroupZipChange(e,physician.id)}
                                  loading={zipLoading}
                                />
                                {groupZipLoading?.[physician.id] && (
                                  <Spin indicator={<LoadingOutlined spin />} 
                                    style={{
                                      position: "absolute",
                                      top: "10px",
                                      right: "10px",
                                    }}
                                  />
                                )}
                              </Form.Item>
                            </Col>
                            <Col span={24} className="d-flex">
                              {groupmessage[physician.id] && (
                                <p className="m-0" style={{color: groupZipData[physician.id]?"green":"red", fontSize: "13px" }}>{groupmessage[physician.id]}</p>
                              )}
                              {(groupZipData?.[physician.id]) && (
                              <Divider 
                                type="vertical" 
                                style={{
                                  borderLeft: "3px solid #8a3ef4",
                                  borderRadius: "3px",
                                  height: "15px",
                                  margin: "0 5px"
                                }} 
                              />
                              )}
                              {groupZipData[physician.id] && (
                              <span className="customZipSpin font-12 text-primary">{groupZipData[physician.id]}</span>
                              )}
                            </Col>
                          </Row>
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  /* Upload Section */
                  <>
                    {!isPreviewMode && (
                      <>
                        <SampleFileContainer>
                          <Typography.Text className="sample-text">
                           Download our sample template to get started.
                          </Typography.Text>
                          <span className="download-link" onClick={downloadSampleFile}>
                            <DownloadOutlined />
                            Download Sample
                          </span>
                        </SampleFileContainer>

                        <Row gutter={[24, 16]}>
                          <Col span={24}>
                            <Form.Item
                              name="physicianFile"
                              label={groupType === 'ccm' ? "Upload Coordinator Details" : "Upload Physician Details"}
                              extra="Supported formats: CSV, XLSX, XLS. Maximum file size: 10MB. This will override the manually entered physicians above."
                            >
                              <Upload {...uploadProps} accept=".csv,.xlsx,.xls">
                                <Button className="text-primary" icon={<UploadOutlined />} size="large" block>
                                  Click to Upload File
                                </Button>
                              </Upload>
                            </Form.Item>
                          </Col>
                        </Row>
                      </>
                    )}

                    {isPreviewMode && previewData.length > 0 && (
                      <div style={{ marginBottom: '20px' }}>
                        {/* Sticky Header */}
                        <div style={{ 
                          position: 'sticky', 
                          top: '0', 
                          zIndex: 10, 
                          background: 'var(--secondary-bg)', 
                          border: '1px solid var(--border-color)', 
                          borderRadius: '4px 4px 0 0',
                          padding: '8px',
                          marginBottom: '0'
                        }}>
                          <Row gutter={[8, 0]} align="middle">
                            <Col span={1}>
                              <div style={{ 
                                fontSize: '13px', 
                                fontWeight: '600', 
                                color: 'var(--primary-text-color)', 
                                textAlign: 'center'
                              }}>
                                #
                              </div>
                            </Col>
                            <Col span={4}>
                              <div style={{ 
                                fontSize: '13px', 
                                fontWeight: '600', 
                                color: 'var(--primary-text-color)'
                              }}>
                                Full Name
                              </div>
                            </Col>
                            <Col span={7}>
                              <div style={{ 
                                fontSize: '13px', 
                                fontWeight: '600', 
                                color: 'var(--primary-text-color)'
                              }}>
                                Email
                              </div>
                            </Col>
                            {/* <Col span={4}>
                              <div style={{ 
                                fontSize: '13px', 
                                fontWeight: '600', 
                                color: 'var(--primary-text-color)'
                              }}>
                                Specialty
                              </div>
                            </Col> */}
                            {/* <Col span={3}>
                              <div style={{ 
                                fontSize: '13px', 
                                fontWeight: '600', 
                                color: 'var(--primary-text-color)'
                              }}>
                                BM
                              </div>
                            </Col> */}
                            <Col span={6}>
                              <div style={{ 
                                fontSize: '13px', 
                                fontWeight: '600', 
                                color: 'var(--primary-text-color)'
                              }}>
                                Country
                              </div>
                            </Col>
                            <Col span={5}>
                              <div style={{ 
                                fontSize: '13px', 
                                fontWeight: '600', 
                                color: 'var(--primary-text-color)'
                              }}>
                                Zip Code
                              </div>
                            </Col>
                            <Col span={1}>
                              <div style={{ 
                                fontSize: '13px', 
                                fontWeight: '600', 
                                color: 'var(--primary-text-color)',
                                textAlign: 'center'
                              }}>
                                
                              </div>
                            </Col>
                          </Row>
                        </div>

                        {/* Preview Data Rows */}
                        <div style={{ 
                          maxHeight: '400px', 
                          overflowY: 'auto',
                          border: '1px solid var(--border-color)',
                          borderTop: 'none',
                          borderRadius: '0 0 4px 4px'
                        }}>
                          {previewData.map((physician, index) => (
                            <div key={physician.id} style={{ 
                              padding: '8px', 
                              borderBottom: index < previewData.length - 1 ? '1px solid var(--border-color)' : 'none',
                              background: physician.alreadyRegistered ? '#fee' : 'var(--primary-bg)',
                              '&:hover': { background: physician.alreadyRegistered ? '#fdd' : 'var(--secondary-bg)' }
                            }}>
                              <Row gutter={[8, 0]} align="middle">
                                <Col span={1}>
                                  <div style={{ 
                                    fontSize: '13px', 
                                    fontWeight: '500', 
                                    color: 'var(--secondary-text-color)', 
                                    textAlign: 'center'
                                  }}>
                                    {index + 1}
                                  </div>
                                </Col>
                                
                                <Col span={4}>
                                  <Input 
                                    size="small" 
                                    value={physician.name}
                                    onChange={(e) => {
                                      const newData = [...previewData];
                                      newData[index].name = e.target.value;
                                      setPreviewData(newData);
                                    }}
                                    style={{ 
                                      border: physician.alreadyRegistered ? '1px solid #ff4d4f' : '1px solid var(--border-color)' 
                                    }}
                                  />
                                </Col>
                                
                                <Col span={7}>
                                  <Input 
                                    size="small" 
                                    value={physician.email}
                                    onChange={(e) => {
                                      const newData = [...previewData];
                                      newData[index].email = e.target.value;
                                      newData[index].alreadyRegistered = false; // Reset registration status when email changes
                                      setPreviewData(newData);
                                    }}
                                    style={{ 
                                      border: physician.alreadyRegistered ? '1px solid #ff4d4f' : '1px solid var(--border-color)' 
                                    }}
                                  />
                                </Col>
                                
                                {/* <Col span={4}>
                                  <Select
                                    size="small"
                                    value={physician.specialty}
                                    onChange={(value) => {
                                      const newData = [...previewData];
                                      newData[index].specialty = value;
                                      setPreviewData(newData);
                                    }}
                                    style={{ width: '100%' }}
                                    options={specialtyOptions}
                                  />
                                </Col> */}
                                
                                {/* <Col span={3}>
                                  <Select
                                    size="small"
                                    value={physician.boardMember ? 'true' : 'false'}
                                    onChange={(value) => {
                                      const newData = [...previewData];
                                      newData[index].boardMember = value === 'true';
                                      setPreviewData(newData);
                                    }}
                                    style={{ width: '100%' }}
                                    options={[
                                      { label: 'Yes', value: 'true' },
                                      { label: 'No', value: 'false' }
                                    ]}
                                  />
                                </Col> */}

                                <Col span={6}>
                                  <Select
                                    size="small"
                                    value={physician.country}
                                    onChange={(value) => {
                                      const newData = [...previewData];
                                      newData[index].country = value;
                                      setPreviewData(newData);
                                    }}
                                    style={{ width: '100%' }}
                                    options={limitedcountry.map(country =>({
                                      label: country.name,
                                      value: country.code,
                                    }))}
                                  />
                                </Col>

                                <Col span={5}>
                                  <Input 
                                    size="small" 
                                    value={physician.zip}
                                    onChange={async (e) => {
                                      const zip = e.target.value;
                                      const newData = [...previewData];
                                      newData[index].zip = zip;
                                      setPreviewData(newData);

                                      await validateUploadedZips(previewData);
                                    }}
                                    
                                  />
                                </Col>
                                
                                <Col span={1}>
                                  <div 
                                    onClick={() => {
                                      const newData = previewData.filter((_, i) => i !== index);
                                      setPreviewData(newData);
                                    }}
                                    style={{ color: '#ff4d4f', cursor: 'pointer', fontSize: '16px' }}
                                  >
<DeleteOutlined />
                                  </div>
                                </Col>
                              </Row>
                              <Col span={24} className="d-flex">
                                {zipValidationResults[index].status && (
                                  <p
                                    className="m-0"
                                    style={{
                                      fontSize: '12px',
                                      color: zipValidationResults[index].status === 'ZIP is valid' ? 'green' : 'red',
                                    }}
                                  >
                                    {zipValidationResults[index].status}
                                  </p>
                                )}
                                {zipValidationResults[index].info && (
                                  <Divider 
                                    type="vertical" 
                                    style={{
                                      borderLeft: "3px solid #8a3ef4",
                                      borderRadius: "3px",
                                      height: "15px",
                                      margin: "0 5px"
                                    }} 
                                  />
                                )}
                                {zipValidationResults[index].info && (
                                  <span className="font-12 text-primary">{zipValidationResults[index].info}</span>
                                )}
                              </Col>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>

              
              </GroupSection>
          </SectionContainer>

                    
        </FormContainer>

        <Divider style={{ margin: "20px 0" }} />

        <Row>
          <Col span={24} className="d-flex justify-end gap-12">
            {isPreviewMode && (
              <CustomSecondaryButton 
                onClick={() => {
                  setIsPreviewMode(false);
                  setPreviewData([]);
                  setFileList([]);
                }}
              >
                Back to Upload
              </CustomSecondaryButton>
            )}
            <CustomSecondaryButton onClick={onClose}>
              Cancel
            </CustomSecondaryButton>
            <CustomButton htmlType="submit" loading={loading} disabled={!isEdit && physicianType === 'individual' && zipData === null}>
              {loading ? "Processing..." : isPreviewMode ? (groupType === 'ccm' ? "Upload Coordinators" : "Upload Physicians") : isEdit ? "Update" : "Add"}
            </CustomButton>
          </Col>
        </Row>
      </Form>
    </Spin>
    </AddPhysicianModalWrapper>
  );
};

export default AddPhysicianFormModal;